<template>
  <div>
    <main class="profile edit">
    <img class="img_glow_left" src="/static/images/home/glow.png">
    <section>
      <h1>{{ getTranslations.home_profile_profile_edit_change_settings }}</h1>
      <h2>{{ getTranslations.home_profile_profile_edit_settings }}</h2>
    </section>

      <avatar-selection-carousel
        :show-title="false"
        type="profile"
        @avatar-selected="this.changeAvatar">
      </avatar-selection-carousel>

    <section class="edit_options">
      <a href="" class="edit_opt_box"
         style="cursor: pointer"
         @click.prevent="showAppropriateModal(0)">
        <h3>{{ getTranslations.home_profile_profile_edit_change_username }}</h3>
        <i class="fas fa-chevron-right"></i>
      </a>
      <a v-if="governorateLength > 0"
         href="" class="edit_opt_box"
         style="cursor: pointer"
         @click.prevent="showAppropriateModal(2)">
        <h3>{{ getTranslations.home_profile_profile_edit_change_governorate }}</h3>
        <i class="fas fa-chevron-right"></i>
      </a>
      <a href="" class="edit_opt_box"
         style="cursor: pointer"
         @click.prevent="showAppropriateModal(1)" v-if="!hideChangePassword">
        <h3>{{ getTranslations.home_profile_profile_edit_change_pin }}</h3>
        <i class="fas fa-chevron-right"></i>
      </a>
    </section>
    <section class="app_settings">
      <h2>{{ getTranslations.home_profile_profile_edit_app_settings }}</h2>
      <div href="#" class="edit_opt_box">
        <p>{{ getTranslations.home_profile_profile_edit_language }}</p>

        <div class="row-selector lang">
          <template v-for="(value, key, index) in localesMappedWithIndices">
            <span
              :key="`lang_${index}`"
              @click.prevent="updateAndStoreNewLanguageAndLocale(key, value[0])"
              :class="['row-option', {selected: key === activeLocale}]"
              style="cursor: pointer">
              {{ value[1] }}
            </span>
            <span :key="`sep_${index}`" v-if="index < totalLocalesMappedWithIndices - 1"> | </span>
          </template>
        </div>
      </div>

      <div class="edit_opt_box">
        <p>{{ getTranslations.home_profile_edit_sound }}</p>
        <div class="row-selector sound">
          <span
            class="row-option"
            @click.prevent="updateSoundsStatus(true)"
            :class="soundChecked ? 'selected' : ''">
            {{ getTranslations.home_settings_sound_ON }}
          </span>
          <span>|</span>
          <span
            class="row-option"
            @click.prevent="updateSoundsStatus(false)"
            :class="!soundChecked ? 'selected' : ''">
            {{ getTranslations.home_settings_sound_OFF }}
          </span>
        </div>
      </div>


      <div class="edit_opt_box">
        <p>{{ getTranslations.home_profile_edit_music }}</p>
        <div class="row-selector music">
          <span
            class="row-option"
            @click.prevent="toggleMusic(true)"
            :class="musicOn ? 'selected' : ''">
            {{ getTranslations.home_settings_sound_ON }}
          </span>
          <span>|</span>
          <span
            class="row-option"
            @click.prevent="toggleMusic(false)"
            :class="!musicOn ? 'selected' : ''">
            {{ getTranslations.home_settings_sound_OFF }}
          </span>
        </div>
      </div>

      <div class="edit_opt_box">
        <p>{{ getTranslations.home_profile_edit_private }}</p>
        <div class="row-selector account">
          <span
            class="row-option"
            @click.prevent="toggleVisibility(true)"
            :class="this.userDetails.hasPrivateProfile ? 'selected' : ''">
            {{ getTranslations.home_settings_private_ON }}
          </span>
          <span>|</span>
          <span
            class="row-option"
            @click.prevent="toggleVisibility(false)"
            :class="!this.userDetails.hasPrivateProfile ? 'selected' : ''">
            {{ getTranslations.home_settings_private_OFF }}
          </span>
        </div>
      </div>
    </section>


    <section class="other_options">
      <h2>{{ getTranslations.home_profile_profile_edit_other_settings }}</h2>
      <a href="" class="edit_opt_box"
      @click.prevent="userChangeStatus()"
      style="cursor: pointer">
        <h3>{{ userStatus }}</h3>
        <i class="fas fa-chevron-right"></i>
      </a>
    </section>
  </main>
    <component :is="modalForSettings" @close="storeModalForSettings(null)"></component>
  </div>
</template>

<script>
import { mapState, mapGetters, mapMutations, mapActions } from 'vuex';
import RegistrationFlowMixin from '@/common/mixins/flow';
import ChangeUsername from '@/components/home/modals/ChangeUsername';
import SetPin from '@/components/home/modals/ChangeLoginPin';
import Unsubscribe from '@/components/home/modals/Unsubscribe';
import UnsubscribeSms from '@/components/home/modals/UnsubscribeSms';
import ResubscribeGame from '@/components/home/modals/ResubscribeGame';
import ResubscribeGameSms from '@/components/home/modals/ResubscribeGameSms';
import modals from '../../../common/modals';
import AvatarSelectionCarousel from "../../common/carousel/AvatarSelectionCarousel";
import ChangeGovernorate from "../modals/ChangeGovernorate";

export default {
  components: {
    AvatarSelectionCarousel
  },
  name: 'profile-edit',
  mixins: [RegistrationFlowMixin],
  data() {
    return {
      userStatus: '',
      editProfilePage: 'editProfile',
      soundChecked: true,
      musicOn: localStorage.getItem('musicOn') !== 'false',
      activeLocale: localStorage.getItem("locale") || "AR",
    };
  },
  created() {
    this.getUserStatusMethod();
    this.setProfilePath(false);
    this.$nextTick(() => {
      this.soundChecked = this.soundsOn;
    });

  },
  updated() {
    this.getUserStatusMethod();
  },
  beforeDestroy() {
    this.setProfilePath(true);
  },
  methods: {
    ...mapMutations('common', [
      'setProfilePath',
      'setSoundsOnOrOff',
      'storeModalForSettings',
    ]),
    ...mapMutations('i18n', [
      'setLocale',
      'updateActiveLocale',
    ]),
    ...mapActions('i18n', [
      'getLocaleAndTranslations',
      'updateUserLanguage',
    ]),
    ...mapActions('profile', [
      'storeAvailablePrizeTypes',
      'storeVisitorWinners',
      'changeVisibility'
    ]),
    ...mapActions('common', [
      'sendAvatarCall',
    ]),
    toggleVisibility(isPrivate) {
      this.changeVisibility(isPrivate);
    },
    toggleMusic(isOn) {
      this.musicOn = isOn;
      this.$updateMusicState(isOn);
    },
    isEligibleForPinChange() {
      return this.userDetails.hasPassword;
    },
    changeAvatar() {
      this.sendAvatarCall();
    },
    showAppropriateModal(actionCode) {
      let modal = '';
      switch (actionCode) {
        case 0:
          modal = ChangeUsername;
          break;
        case 1:
          modal = SetPin;
          break;
        case 2:
          modal = ChangeGovernorate;
          break;
        default:
          break;
      }
      this.storeModalForSettings(modal);
      modals.setupCommonModal({
        afterHideCallback: () => {
          this.storeModalForSettings(null)
        }
      })
    },
    userChangeStatus() {
      if (this.userDetails.subscribed) {
        if (this.subAndUnsubViaSMS) {
          if (this.reoptinAndOptoutConfig === 'OPTOUT_SMS' || this.reoptinAndOptoutConfig === 'REOPTIN_OPTOUT_SMS') {
            this.storeModalForSettings(UnsubscribeSms);
          } else {
            this.storeModalForSettings(Unsubscribe);
          }
        } else {
          this.storeModalForSettings(Unsubscribe);
        }
      } else {
        // eslint-disable-next-line
        if (this.subAndUnsubViaSMS) {
          if (this.reoptinAndOptoutConfig === 'REOPTIN_SMS' || this.reoptinAndOptoutConfig === 'REOPTIN_OPTOUT_SMS') {
            this.storeModalForSettings(ResubscribeGameSms);
          } else {
            this.storeModalForSettings(ResubscribeGame);
          }
        } else {
          this.storeModalForSettings(ResubscribeGame);
        }
      }
      modals.setupCommonModal({
        afterHideCallback: () => {
          this.storeModalForSettings(null);
        }
      });
    },
    getUserStatusMethod() {
      if (!this.userDetails.subscribed) {
        this.userStatus = this.getTranslations.home_settings_resubscribe;
      } else {
        this.userStatus = this.getTranslations.home_settings_unsubscribe;
      }
    },
    updateSoundsStatus(isChecked) {
      this.soundChecked = isChecked;
      this.setSoundsOnOrOff(this.soundChecked);
      localStorage.setItem('soundsOn', this.soundChecked);
    },
    updateAndStoreNewLanguageAndLocale(locale, localeIndex) {
      this.updateActiveLocale(localeIndex);
      localStorage.setItem('locale', locale);
      this.activeLocale = locale;
      this.setLocale({ currentLocale: locale });
      this.updateUserLanguage().then(() => {
        this.getLocaleAndTranslations().then(() => {
          this.storeAvailablePrizeTypes(this.getLocale);
          this.storeVisitorWinners(this.getLocale);
        });
      });
    },
  },
  watch: {
    activeLocale(newLocale) {
      if (newLocale !== this.currentLocale) {
        console.log('Locale changed to:', newLocale);
        window.location.reload();
      }
    },
  },
  computed: {
    ...mapState('common', [
      'hideLangSelection',
      'hideChangePassword',
      'subAndUnsubViaSMS',
      'reoptinAndOptoutConfig',
      'soundsOn',
      'userDetails',
      'modalForSettings',
      'governorateLength'
    ]),
    ...mapState('i18n', [
      'settingsPageLocales',
      'localesMappedWithIndices',
    ]),
    ...mapState('profile', [
      'jwtInVuex',
    ]),
    ...mapGetters('i18n', [
      'getTranslations',
      'getTranslationByOperator',
      'getLocale',
    ]),
    totalLocalesMappedWithIndices(){
      return Object.keys(this.localesMappedWithIndices).length;
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/home/profile/ProfileEdit.vue